import { render, staticRenderFns } from "./myMatches.vue?vue&type=template&id=6c5dee63"
import script from "./myMatches.vue?vue&type=script&lang=js"
export * from "./myMatches.vue?vue&type=script&lang=js"
import style0 from "./myMatches.vue?vue&type=style&index=0&id=6c5dee63&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports